import { Environment } from './environment.interface';
export { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  brands: {
    enelx: {
      baseUrl: 'https://customer-offers.apps.enelx.com/v1',
      globalNavUrl: 'https://global-nav.svcs.enelx.net/api/v1',
      baseUrlV2: 'https://customer-offers.apps.enelx.com/v2'
    }
  },
  cdn: 'https://cdn.apps.enelx.com',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US'
  }
};
